import React from 'react';
import {
	CompanyProfilesTableFragment,
} from '@app/site/secured/general-settings/fragment/property-access/CompanyProfilesTableFragment';
import FormButton from '@app/component/form/button/FormButton';
import useModal from '@app/component/overlays/modal/ModalRef';
import { useCompanyHotels } from '@app/site/secured/rateshopper/rates/provider/useCompanyHotels';
import SaveCompanyProfileModal from '@app/site/secured/general-settings/fragment/property-access/modal/SaveCompanyProfileModal';


const PropertyAccessSettingsPage = React.memo(() => {

	const modal = useModal();
	const { companyHotels } = useCompanyHotels();

	return <>
		<div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none bg-white p-4 sm:p-10 rounded-xl">
			<div>
				<div className="sm:flex sm:items-center">
					<div className="sm:flex-auto">
						<h1 className="text-base font-semibold leading-6 text-gray-900">
							Manage Property Access
						</h1>
						<p className="text-sm leading-6 text-gray-500">
							Assign specific users and permissions to designated properties!
						</p>
					</div>
					<div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
						<FormButton state="primary" onClick={() => modal.open()}>Add New User</FormButton>
					</div>
				</div>
				<fieldset className="mt-3 pt-6 border-t border-gray-200">
					<CompanyProfilesTableFragment />
				</fieldset>
			</div>
		</div>
		<SaveCompanyProfileModal companyHotels={companyHotels} ref={modal.ref} companyProfile={null}/>
	</>;
});

export default PropertyAccessSettingsPage;

